import angular from 'angular'
import component from './storyToolbar.component'

export default angular
  .module('ellipsis.storyToolbar', [])
  .component('storyToolbar', component)
